const siteUrl = '',
  apiUrl = process.env.VUE_APP_API_URL || '/api'

export const settings = {
  siteName: ''
}

class URL {
  constructor(base) {
    this.base = base
  }

  path(path, args) {
    path = path.split('.')
    let obj = this,
      url = this.base

    for (let i = 0; i < path.length && obj; i++) {
      if (obj.url) {
        url += '/' + obj.url
      }

      obj = obj[path[i]]
    }
    if (obj) {
      url = url + '/' + (typeof obj === 'string' ? obj : obj.url)
    }

    if (args) {
      for (let key in args) {
        url = url.replace(':' + key, args[key])
      }
    }

    return url
  }
}

export const api = Object.assign(new URL(apiUrl), {
  url: '',

  login: {
    url:     'login',
    refresh: 'refresh'
  },

  logout: 'logout',

  registro: 'registro',

  password: {
    url:    'password',
    forgot: 'email',
    reset:  'reset'
  },

  me: 'me',

  perfil: {
    url: 'perfil',
    live_mode: 'live-mode'
  },

  titulos: {
    url:       'lotes-titulos',
    cancelar:  'cancelar',
    formato:   'formato',
    layout:    'layout',
    reporte:   'reporte',
    single:    ':id',
    firmar:    ':id/firmar',
    firmantes: ':id/firmantes',
    folios:    ':id/folios',
    resultado: ':id/resultado',
    sep:       ':id/sep',
    zip:       ':id/zip',
    cadenas:    ':id/cadenas',
    
    titulos: {
      url:    ':id/titulos',
      single: ':id2',
      pdf: ':id2/pdf',
    },
  },

  lotes_certificados: {
    url:           'lotes-certificados',
    reporte:       'reporte',
    single:        ':id',
    formato_pagos: ':id/formato-pagos',
    autorizar:     ':id/autorizar',
    firmar:        ':id/firmar',
    firmantes:     ':id/firmantes',
    folio_pago:    ':id/folio-pago',
    xlsx:          ':id/xlsx',
    zip:           ':id/zip',

    certificados: {
      url:           ':id/certificados',
      single:        ':id2',

      calificaciones: {
        url:    ':id2/calificaciones',
        single: ':id3',
      },
    },
  },

  programas: {
    url:          'programas-estudio',
    autorizar:    'autorizar',
    formato:      'formato',
    layout:       'layout',
    refactorizar: 'refactorizar',
    xlsx:         'xlsx',
    single:       ':id',

    asignaturas: {
      url:    ':id/asignaturas',
      single: ':id2',
    },
  },

  campus: {
    url:    'campus',
    single: ':id',
  },

  carreras: {
    url:    'carreras',
    single: ':id',
  },

  responsables: {
    url:    'responsables',
    single: ':id',
    firma:  ':id/firma',
  },

  usuarios: {
    url:    'usuarios',
    single: ':id',

    solicitudes: {
      url:    'solicitudes',
      single: ':id',
    },
  },

  instituciones: {
    url:    'instituciones',
    single: ':id',
  },

  catalogos: {
    url:                              'catalogos',
    autorizacion_reconocimiento:      'autorizacion-reconocimiento',
    cargo:                            'cargo',
    entidad_federativa:               'entidad-federativa',
    fundamento_legal_servicio_social: 'fundamento-legal-servicio-social',
    genero:                           'genero',
    modalidad:                        'modalidad',
    modalidad_titulacion:             'modalidad-titulacion',
    motivo_cancelacion:               'motivo-cancelacion',
    nivel_de_estudio:                 'nivel-de-estudio',
    observacion:                      'observacion',
    tipo_asignatura:                  'tipo-asignatura',
    tipo_certificacion:               'tipo-certificacion',
    tipo_estudio_antecedente:         'tipo-estudio-antecedente',
    tipo_periodo:                     'tipo-periodo',
    capturar_certificados:            'capturar-certificados',
    bc_observacion:                   'bc-observacion',
  },
})
